export const INTERACTIVE_SELECTOR = `
button,
input,
label,
select,
textarea,
a,
[role="button"],
[role="radio"],
[data-interactive]
`;
